export const Status = {
  success: "01",
  nomatch: "00",
  wide: "05",
  empty: "06"
}
